import { Outlet, useLocation } from 'react-router-dom';
import { useRouteTransition } from '../../lib/routing/useRouteTransition';
import type { SignedInShellOutletContext } from './SignedInShell';

export function RouteTransitionOutlet({
  context,
}: {
  context: SignedInShellOutletContext;
}) {
  const location = useLocation();
  const transition = useRouteTransition();

  return (
    <div
      key={location.key}
      className="pn-route-transition"
      data-route-transition={transition}
      data-testid="route-transition-outlet"
    >
      <Outlet context={context} />
    </div>
  );
}
